/**
 * Generates multi-level sorting criteria
 * @param {string} frequency - 'annual' or 'monthly'
 * @param {string|null} coverType - Optional: 'H' (home), 'C' (contents), 'HC' (home & contents). For CAR or other verticals, omit or pass null.
 * @returns {Array} Sort criteria configuration
 */
export const getMultiLevelSortCriteria = (frequency, coverType = null) => {
    const criteria = [
        { field: `productMeta.price.${frequency}Premium`, dir: 'asc', type: 'numeric' }
    ];
    switch (coverType) {
        case 'HC':
            criteria.push(
                { field: 'productMeta.homeExcess.amount', dir: 'asc', type: 'numeric' },
                { field: 'productMeta.contentsExcess.amount', dir: 'asc', type: 'numeric' },
                { field: 'providerMeta.name', dir: 'asc', type: 'alpha' }
            );
            break;
        case 'H':
            criteria.push(
                { field: 'productMeta.homeExcess.amount', dir: 'asc', type: 'numeric' },
                { field: 'providerMeta.name', dir: 'asc', type: 'alpha' }
            );
            break;
        case 'C':
            criteria.push(
                { field: 'productMeta.contentsExcess.amount', dir: 'asc', type: 'numeric' },
                { field: 'providerMeta.name', dir: 'asc', type: 'alpha' }
            );
            break;
        default:
            criteria.push(
                { field: 'productMeta.excess', dir: 'asc', type: 'numeric' },
                { field: 'providerMeta.name', dir: 'asc', type: 'alpha' }
            );
            break;
    }
    return criteria;
};
